import { DefaultValue, selector, selectorFamily, } from 'recoil';
import { TriStateType } from '../../types';
export function selectedSelector({ key, select, }) {
    return selector({
        key,
        get: ({ get }) => {
            const sections = get(select);
            return sections.length > 0
                ? TriStateType.getValue(sections[0].selected) || false
                : false;
        },
        set: ({ get, set }, selected) => {
            const sections = get(select);
            set(select, sections.map((is) => ({
                ...is,
                selected: TriStateType.fromBoolean(selected instanceof DefaultValue ? false : selected),
            })));
        },
    });
}
export function selectedSelectorFamily({ key, select }) {
    return selectorFamily({
        key,
        get: (params) => ({ get }) => {
            const section = get(select(params));
            return TriStateType.getValue(section.selected) || false;
        },
        set: (params) => ({ get, set }, selected) => {
            const section = get(select(params));
            set(select(params), {
                ...section,
                selected: TriStateType.fromBoolean(selected instanceof DefaultValue ? false : selected),
            });
        },
    });
}
